import { create } from 'zustand';
import Env from '@/helpers/Env';
import {
  getUrlString,
  getUrlBoolean,
  getUrlInt,
  getUrlFloat,
} from '@/helpers/UrlParam';

import * as config from '@/config/games/beer';
import { number } from 'prop-types';

export const useGameStore = create((set) => ({
  config,

  // ****************************************
  // LOADED
  // ****************************************
  setLoaded: () =>
    set((state) => {
      return { loaded: true };
    }),

  loadProgress: 0,
  setLoadProgress: (val) =>
    set((state) => {
      return { loadProgress: val };
    }),

  // ****************************************
  // READY
  // ****************************************
  ready: false,
  setReady: (val) =>
    set((state) => {
      return { ready: true };
    }),

  // ****************************************
  // CRASHED
  // ****************************************
  hasCrashed: false,
  setHasCrashed: (val, data = {}) =>
    set((state) => {
      return { hasCrashed: val, crashedData: data };
    }),

  // ****************************************
  // GAME
  // ****************************************
  // stage: 0,
  // setStage: (val) =>
  //   set((state) => {
  //     return { stage: val };
  //   }),
}));
